module.exports = __webpack_public_path__ + "img/laboratorio.faf068d8.png";